import { render, staticRenderFns } from "./tmk-proposed-insureds.vue?vue&type=template&id=3734a2b2&scoped=true&"
import script from "./tmk-proposed-insureds.vue?vue&type=script&lang=js&"
export * from "./tmk-proposed-insureds.vue?vue&type=script&lang=js&"
import style0 from "./tmk-proposed-insureds.vue?vue&type=style&index=0&id=3734a2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734a2b2",
  null
  
)

export default component.exports